<template>
  <div class="report_grid" @click="viewDetail">
    <div class="row">
      <div class="col-sm-4">
        <img v-if="activity.type === 'Video'" src="@/assets/image/task_video.png" style="max-height: 70px;">
        <img v-if="activity.type === 'Reading'" src="@/assets/image/task_reading.png" style="max-height: 70px;">
        <img v-if="activity.type === 'uReply'" src="@/assets/image/task_ureply.png" style="max-height: 70px;">
      </div>
      <div class="col-sm-8">
        <div class="report_grid_title">{{ activity.name }}</div>
      </div>
    </div>
    <div>{{ activity.description }}</div>
    <div class="row">
      <div class="col-sm-8" style="margin-top:20px; white-space: nowrap;">
        <div>
          <span>班級進度: </span>
          <font class="comp_rate">{{ completion_rate }}%</font>
        </div>
        <div>
          <span>觀看次數: {{ no_of_views }}</span>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="donut-size" style="font-size:4.4em;" percent="0">
          <div class="pie-wrapper">
            <span class="label" style="display:none">
              <span class="num">0</span>
              <span class="smaller">%</span>
            </span>
            <div class="pie" style="clip: rect(0px, 1em, 1em, 0.5em);">
              <div class="left-side half-circle" style="border-width: 0.2em; transform: rotate(0deg);"></div>
              <div class="right-side half-circle" style="transform: rotate(0deg); border-width: 0.2em;"></div>
            </div>
            <div class="shadow" style="border-width: 0.2em;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style type='text/css' scoped>
.report_grid {
  color: rgb(146,147,150);
  font-weight: lighter;
  font-size: 11pt;
  /*max-width:380px;*/
  padding:10px;
  border: 1px solid rgb(249,228,226);
  border-radius: 20px;
  margin:10px 10px;
  cursor:pointer;
  height: 300px;
  width: calc( 50% - 21px);
}
.report_grid_title {
  font-weight:bolder;
  font-size:12pt;
  margin-top:10px;
}
.shadow {
  position: absolute;
  right: 50px;
}
@media screen and (max-width: 790px) {
  .report_grid {
    width: auto;
  }
}
</style>
<script>
export default {
  props: {
    week_id: Number,
    activity: Object
  },
  data () {
    return {
      course_id: parseInt(this.$route.query.course),
      completion_rate: '0',
      no_of_views: '0'
    }
  },
  methods: {
    viewDetail: function () {
      this.$router.push({ name: 'ClassReportDetail', query: { course: this.course_id, week: this.week_id, activity: this.activity.id } })
    }
  },
  mounted () {
    this.$store.dispatch('request', {
      route: 'courses/' + this.course_id + '/weeks/' + this.week_id + '/activities/' + this.activity.id + '/report'
    }).then(r => {
      // console.log(r)
      this.completion_rate = r.completion_rate.toFixed(0)
      this.no_of_views = r.no_of_views
    })
  }
}
</script>
